export const BASE_URL = 'https://admin.metfastcharge.net/';